/* import __COLOCATED_TEMPLATE__ from './group-appointment.hbs'; */
import SiteBillingAccountHistoryContainersAppointment from './appointment';

export default class SiteBillingAccountHistoryContainersGroupAppointment extends SiteBillingAccountHistoryContainersAppointment {}
